/**
 * Nom français d'une couleur CSS hexadécimale, par classification de teinte.
 *
 * Usage : photocopie N&B — les pastilles colorées des programmes de
 * construction (« trace en bleu / rouge / vert ») deviennent des gris
 * indistincts à la photocopie ; on affiche le nom de la couleur en toutes
 * lettres à côté de la pastille pour que la consigne reste exécutable.
 *
 * Classification par teinte HSL (robuste aux nuances : #378ADD et #2563eb
 * donnent tous deux « bleu »). Retourne null si la couleur est illisible ou
 * quasi neutre (gris/noir — pas d'ambiguïté à la photocopie).
 */
export const nomCouleur = (hex) => {
    if (typeof hex !== 'string') return null;
    const m = hex.trim().match(/^#?([0-9a-f]{6})$/i);
    if (!m) return null;
    const n = parseInt(m[1], 16);
    const r = (n >> 16) & 255;
    const g = (n >> 8) & 255;
    const b = n & 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;
    // Quasi neutre (gris, noir, blanc) : pas de nom — indiscernable exprès
    if (delta < 30) return null;
    let h;
    if (max === r) h = ((g - b) / delta) % 6;
    else if (max === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = (h * 60 + 360) % 360;
    if (h < 15) return 'rouge';
    if (h < 45) return 'orange';
    if (h < 70) return 'jaune';
    if (h < 160) return 'vert';
    if (h < 200) return 'cyan';
    if (h < 260) return 'bleu';
    if (h < 300) return 'violet';
    if (h < 335) return 'rose';
    return 'rouge';
};
